import { IAddress } from '@pepperhq/types-sdk';
import { EOrderDeliveryStatus, IOrderReadResourceV18 } from 'components/order/model/Order';
import { UserAddress } from 'components/user/model/User';
import moment, { DurationInputObject } from 'moment';

export const DELIVERY_MAX_WIDTH = 550;

export function addressObjectToString(address?: UserAddress | IAddress | null) {
    return address
        ? [
              address.address.line1,
              address.address.line2,
              address.address.city,
              address.address.region,
              address.address.country,
              address.address.postalCode
          ]
              .filter(Boolean)
              .join(', ')
        : '';
}

export function getDeliveryTimeEstimate(date?: Date, deadlineDate?: Date) {
    const currentDate = new Date();
    if (date && deadlineDate) {
        return `${moment(date).diff(currentDate, 'minutes')} - ${moment(deadlineDate).diff(
            currentDate,
            'minutes'
        )} minutes`;
    }
    if (date) {
        return `${moment(date).diff(currentDate, 'minutes')} minutes`;
    }
}

const deliveryStatusLocalString = {
    [EOrderDeliveryStatus.PENDING]: 'DELIVERY_STATUS_PENDING',
    [EOrderDeliveryStatus.LOOKING_FOR_DRIVER]: 'DELIVERY_STATUS_LOOKING_FOR_DRIVER',
    [EOrderDeliveryStatus.DRIVER_EN_ROUTE_TO_PICKUP]: 'DELIVERY_STATUS_DRIVER_EN_ROUTE_TO_PICKUP',
    [EOrderDeliveryStatus.DRIVER_AT_PICKUP]: 'DELIVERY_STATUS_DRIVER_AT_PICKUP',
    [EOrderDeliveryStatus.IN_TRANSIT]: 'DELIVERY_STATUS_IN_TRANSIT',
    [EOrderDeliveryStatus.DRIVER_AT_DROPOFF]: 'DELIVERY_STATUS_DRIVER_AT_DROPOFF',
    [EOrderDeliveryStatus.SUCCESS]: 'DELIVERY_STATUS_DELIVERED',
    [EOrderDeliveryStatus.FAILED]: 'DELIVERY_STATUS_FAILED',
    [EOrderDeliveryStatus.CANCELLED]: 'DELIVERY_STATUS_CANCELLED'
};

export function getOrderDeliveryStatusString(order?: IOrderReadResourceV18 | null) {
    if (!order?.delivery?.status) {
        return undefined;
    }
    return deliveryStatusLocalString[order?.delivery?.status] ?? order?.delivery?.status;
}

export function isDeliveryOrderActive(order: IOrderReadResourceV18, overridePadding?: DurationInputObject) {
    const padding = overridePadding ?? {
        hours: 48
    };
    return (
        order?.delivery &&
        (order?.delivery?.inProgress ||
            moment(
                order?.delivery?.lastStatusAt ??
                    order?.delivery?.eta?.dropoffDeadline ??
                    order?.delivery?.eta?.dropoff ??
                    order?.createdAt
            )
                .add(padding)
                .isAfter(new Date()))
    );
}

export function getDeliveryAddressTitle(address?: UserAddress) {
    return address?.address?.line2
        ? `${address?.address?.line2}, ${address?.address?.line1}`
        : address?.address?.line1;
}
